import { AppFilter } from './../../../../models/app-filter.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbMorador } from 'app/abstract/full-pages/meus-dados/morador.abstract';

@Injectable({ providedIn: 'root' })
export class MoradorService extends AbMorador {

  constructor(http: HttpClient) {
    super(http);
  }


  deletarMorador(id: number) {
    return this.delete("morador/", id);
  }

  public getAllMoradores(filter: AppFilter): Observable<any> {
    return this.get(`morador/filter/${filter.encode()}`);
  }
}